$('.delivery .options-wrapper').on('click', function(e){
  $('.delivery .options-wrapper').removeClass('active');
  $(this).addClass('active');

  var shipping_to = $('.delivery .options-wrapper .option:checked').val();
  if (shipping_to == 1) {
    $('.office-info').slideUp('fast');
    $('.address-info').slideDown('fast');
  }else{
    $('.office-info').slideDown('fast');
    $('.address-info').slideUp('fast');
  }

})


$('.payment .options-wrapper').on('click', function(e){
  $('.payment .options-wrapper').removeClass('active');
  $(this).addClass('active');

  var payment = $('.payment .options-wrapper .option:checked').val();

  if (payment == 1) {
    $('.pay-with-card').slideUp('fast');
    $('.pay-on-delivery').slideDown('fast');
  }else{
    $('.pay-with-card').slideDown('fast');
    $('.pay-on-delivery').slideUp('fast');
  }

})


$('.invoice_check').on('change', function(e){
  var invoice = $('.invoice_check:checked').val();
  if (invoice == 1) {
    $('.invoice-wrapper').slideDown('fast');
  }else{
    $('.invoice-wrapper').slideUp('fast');
  }
})


$(document).on("click", ".open-courier-modal", function () {
    var modalUrl = $(this).attr("data-modal-href");
    $("#courier-modal").find(".modal-content").load(modalUrl, function(){
        Livewire.rescan();
    });
});

$(document).on("click", ".open-office-modal", function () {
    var url = $(".open-office-modal").attr("data-modal-href"); // Use $(this) to get the correct element
    $("#courier-modal")
        .find(".modal-content")
        .load(url, function () {
            Livewire.rescan();
        });
});
